export function alliedGroupsetFits(frame, groupset) {
  const name = frame && frame.name || '';
  const drive = groupset && groupset.name || '';
  if (name === 'Allied ABLE (2026)') return /sram/i.test(drive) && /axs/i.test(drive) && /\b1x\b/i.test(drive) && /xplr/i.test(drive);
  // Single chainring only and no front-derailleur mount; Avona builds it with electronic 1x.
  if (/^Avona Callis 32\b/i.test(name)) return /\b1x\b/i.test(drive) && /axs|di2|wireless/i.test(drive);
  if (name === 'Allied ECHO (2026)') return /di2|axs|wireless/i.test(drive) && !/\bmtb\b|\btri\b/i.test(drive);
  return true;
}
